import axios, {AxiosResponse} from 'axios'
import {HTTPResponseModel} from '../../../../common/models/HTTPResponseModel'
import {QueryState} from '../../../../../_metronic/helpers'
// import {AuthModel, UserModel} from './_models'
// import { HTTPResponseModel } from '../../../common/models/HTTPResponseModel'

const API_URL = process.env.REACT_APP_API_URL

export const GET_PROJECT_LIST_URL = `${API_URL}project/ListProject`
export const GET_DROPDOWN_DATA_URL = `${API_URL}global/DropdownList`
export const GET_PROJECT_URL = `${API_URL}project/GetProject`
export const GET_SEARCH_COMPANY_BY_KEY_WORD_URL = `${API_URL}worksite/SearchCompanyByKeyword`
export const GET_SEARCH_PERSON_BY_KEY_WORD_URL = `${API_URL}worksite/SearchPersonByKeyword`
export const GET_WORK_SITE_URL = `${API_URL}worksite/GetWorkSite`
export const POST_WORK_SITE_URL = `${API_URL}worksite/PostWorkSite`
export const PUT_WORKSITE_URL = `${API_URL}worksite/PutWorkSite`
export const PUT_PROJECT_URL = `${API_URL}project/PutProject`
export const GET_USAGE_COUTERS = `${API_URL}usage/GetUsageCounters?Guid=`
export const DEL_PROJECT_URL = `${API_URL}project/DeleteProject`

export const GET_PROPOSAL_LIST_MATERIEL = `${API_URL}proposal/ListMaterial?ProjectGuid=`
export const GET_PROPOSAL_URL = `${API_URL}proposal/GetProposal?`
export const GET_PROPOSAL_SETTINGS = `${API_URL}proposal/GetProposalSettings?`
export const PUT_PROPOSAL_SUBMIT = `${API_URL}proposal/Submit`
export const GET_VIGILANCE_POINT = `${API_URL}global/GetSetting?Code=PointVigilance`


export const getProjectList = async (
  {Keyword}: QueryState,
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(
    GET_PROJECT_LIST_URL + '?' + new URLSearchParams({Keyword: Keyword || ''})
  )
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await getProjectList({Keyword}, onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

export const getBuildingTypeList = async (
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(
    GET_DROPDOWN_DATA_URL + '?prelistName=BuildingType&T=' + (new Date().getTime())
  )
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await getBuildingTypeList(onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

export const getProjectTypeList = async (
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(
    GET_DROPDOWN_DATA_URL + '?prelistName=ProjectType&T=' + (new Date().getTime())
  )
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await getProjectTypeList(onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

export const getCountryList = async (
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(GET_DROPDOWN_DATA_URL + '?prelistName=Country&T=' + (new Date().getTime()))
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await getCountryList(onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

export const getWorkSiteTypeList = async (
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(
    GET_DROPDOWN_DATA_URL + '?prelistName=WorkSiteType&T=' + (new Date().getTime())
  )
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await getWorkSiteTypeList(onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

export const getProjectByGuid = async (
  {
    Guid,
  }: {
    Guid: string
  },
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(
    GET_PROJECT_URL + '?' + new URLSearchParams({Guid})
  )
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await getProjectByGuid({Guid}, onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

export const getSearchCompanyClient = async (
  {
    Keyword,
    GuidToExclude,
    SelectedValueGuid,
  }: {
    Keyword: string
    GuidToExclude: string
    SelectedValueGuid: string
  },
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(
    GET_SEARCH_COMPANY_BY_KEY_WORD_URL +
      '?' +
      new URLSearchParams({Keyword, GuidToExclude, SelectedValueGuid})
  )
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await getSearchCompanyClient({Keyword, GuidToExclude, SelectedValueGuid}, onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

export const getSearchPersonWorksite = async (
  {
    CompanyGuid,
    SelectedValueGuid,
    Keyword,
  }: {
    CompanyGuid: string
    SelectedValueGuid: string
    Keyword: string
  },
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(
    GET_SEARCH_PERSON_BY_KEY_WORD_URL +
      '?' +
      new URLSearchParams({Keyword, CompanyGuid, SelectedValueGuid})
  )
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await getSearchPersonWorksite({Keyword, CompanyGuid, SelectedValueGuid}, onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

export const postWorkSite = async (
  data: any,
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.post<HTTPResponseModel>(POST_WORK_SITE_URL, data)
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await postWorkSite(data, onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

export const putWorkSite = async (
  data: any,
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {Message?: string, MessageType?: string, Toast?: string, ToastType?: string}) => void,
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.put<HTTPResponseModel>(PUT_WORKSITE_URL, data)
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await putWorkSite(data, onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

export const getWorkSite = async (
  {Guid}: {Guid: string},
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {Message?: string, MessageType?: string, Toast?: string, ToastType?: string}) => void,
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(
    GET_WORK_SITE_URL + '?' + new URLSearchParams({Guid})
  )
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await getWorkSite({Guid}, onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

export const puProjectData = async (
  data: any,
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {Message?: string, MessageType?: string, Toast?: string, ToastType?: string}) => void,
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.put<HTTPResponseModel>(PUT_PROJECT_URL, data)
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await puProjectData(data, onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

export const getUsageCounters = async (
  Guid: string,
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {Message?: string, MessageType?: string, Toast?: string, ToastType?: string}) => void,
  ): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(GET_USAGE_COUTERS + Guid)
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await getUsageCounters(Guid, onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

export const delProjectData = async (
    Guid: string,
    onAccessLost?: (message: string) => void,
    onToastOrMessage?: (toastOrMessage: {Message?: string, MessageType?: string, Toast?: string, ToastType?: string}) => void,
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.delete<HTTPResponseModel>(DEL_PROJECT_URL, {
    params: {
      Guid: Guid
    }
  })
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await delProjectData(Guid, onAccessLost, onToastOrMessage)
  } else if (
      ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
      ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
      ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

export const getProposalMaterialList = async (
  ProjectGuid: string,
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(
    GET_PROPOSAL_LIST_MATERIEL + ProjectGuid
  )
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await getProposalMaterialList(ProjectGuid, onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

export const getProposal = async (
  {ProjectGuid, MaterialGuid}: {ProjectGuid: string, MaterialGuid: string},
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(
    GET_PROPOSAL_URL + new URLSearchParams({ProjectGuid: ProjectGuid || '', MaterialGuid: MaterialGuid || ''})
  )
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await getProposal({ProjectGuid, MaterialGuid}, onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

export const getProposalSettings = async ({
  ProjectGuid,
  MaterialGuid,
}: {
  ProjectGuid: string
  MaterialGuid: string
},
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(
    GET_PROPOSAL_SETTINGS + 'ProjectGuid=' + ProjectGuid + '&MaterialGuid=' + MaterialGuid
  )
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await getProposalSettings({ProjectGuid, MaterialGuid}, onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

export const putProposalSubmit = async (
  data: any,
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {Message?: string, MessageType?: string, Toast?: string, ToastType?: string}) => void,
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.put<HTTPResponseModel>(PUT_PROPOSAL_SUBMIT, data)
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await putProposalSubmit(data, onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

export const getPointVigilance = async (
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(GET_VIGILANCE_POINT + '&T=' + (new Date().getTime()))
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await getPointVigilance(onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}
